module.exports = __webpack_public_path__ + "img/attendance.448b699.png";